import { connect } from 'react-redux';
import moment from 'moment-timezone';

import {
  getMyPermissions,
  getProjectZoneId,
  getSelectedSegment,
} from '../../../reducers/analyticsApp';
import SegmentSummaryGrid from '../../../components/segment/execution/SummaryGrid';
import { staticPermissions } from '../../../constants/authorization';
import { deleteSegment, duplicateSegment, startUpdateSegment } from '../../../actions/segment';

const DATE_FORMAT = 'YYYY-MM-DD';

const mapStateToProps = (state) => {
  const segment = getSelectedSegment(state);
  const zoneId = getProjectZoneId(state);
  const hasPermission = getMyPermissions(state).has(staticPermissions.SEGMENT_MANAGE);

  return {
    item: segment,
    hasPermission,
    description: segment.dateRange
      ? `Date range: ${moment
          .tz(segment.dateRange.from, zoneId)
          .format(DATE_FORMAT)} \u2013 ${moment
          .tz(segment.dateRange.to, zoneId)
          .subtract(1, 'days')
          .format(DATE_FORMAT)}`
      : `Date range: Query's range`,
  };
};

const mapDispatchToProps = (dispatch, { navigate, tenantId }) => ({
  onDelete: (item) => {
    dispatch(deleteSegment(item.id));
  },
  onUpdate: (item) => {
    dispatch(startUpdateSegment(item));
    navigate(`/${tenantId}/segments/update/${item.id}`);
  },
  onDuplicate: (item) => {
    dispatch(duplicateSegment(item));
    navigate(`/${tenantId}/segments/add`);
  },
  showExposureSQLButton: false,
});

export default connect(mapStateToProps, mapDispatchToProps)(SegmentSummaryGrid);
